import apiWithAuth from './apiWithAuth';

const refundReturnApi = {

  // Get the latest refund return policy
  getRefundReturn: async () => {
    try {
      const response = await apiWithAuth.get('/website-main/refund-return/public');
      return { success: true, data: response.data };
    } catch (error) {
      if (error.response?.status === 404) {
        return { success: true, data: null }; // No policy exists yet
      }
      return { success: false, error: error.response?.data?.error || 'Failed to load refund return policy' };
    }
  },

  // Create or update refund return policy
  saveRefundReturn: async (payload) => {
    try {
      const response = await apiWithAuth.put('/website-main/refund-return/refund-return', payload);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Failed to save refund return policy' };
    }
  },

  // Delete refund return policy
  deleteRefundReturn: async () => {
    try {
      await apiWithAuth.delete('/website-main/refund-return/refund-return');
      return { success: true };
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Failed to delete refund return policy' };
    }
  },
};

export default refundReturnApi;